module.exports = __webpack_public_path__ + "img/login.7fc6ebee.jpg";